import React, {useEffect, useState} from 'react';
import {FormPageRoot, ThemedButton, ThemedDialog, ThemedInput} from "../../../index";
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {checkNullStr, getDefStr, getJsonValue, isBoolTrue, isJsonValueTrue, vhToPx} from "../../../../common/fusion-ui/utils/ReactUtils";
import {focusFormIdElement, getUserSessionField, printError, printLog, sendRequest} from "../../../utils/AppUtils";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {EVENT_INPUT_MAX_LEN, ModuleFieldsData, ModuleRouteUrls, Modules, ReqUrls,} from "../../../config/AppConfig";
import {Flexbox, Image, Label, MsgBox} from "../../../../common/fusion-ui";
import {CssVariant, Messages} from "../../../../common/fusion-ui/config/FusionConfig";
import {useInternetStatus} from "../../../../common/fusion-ui/hook";
import {UnderMaintenance, UnderMaintenanceMsg} from "../../../../common/CommonConfig";

const News_Recom_FormPage = React.memo(({asPanel = false, redirectUrl}) => {
    const TAG = "News_Recom_FormPage";

    const moduleName = Modules.News;
    const resModule = Modules.Resources;
    const FormFields = ModuleFieldsData[moduleName];

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();

    const FOCUS_DELAY = 2000;

    const Fields = {
        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        isPdfFileLoading: 'isPdfFileLoading',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',

        showSuccessDialog: 'showSuccessDialog',
        successDialogOnHide: 'successDialogOnHide',
    };
    const [fieldsData, setFieldsData] = useState({});
    // const [formData, setFormData] = useState(News_Recom_FormPage_Data);
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});

    useEffect(() => {
        // setFormData({});
        if (!checkNullStr(getField(Fields.isDataFound))) {
            updateField(Fields.isDataFound, true);
            updateField(Fields.isDataLoading, false);
        }
    }, []);

    return (<>
        {isBoolTrue(asPanel) ? createForm() : createFormPage()}
        {createSuccessDialog()}
    </>)

    function createFormPage() {
        return <FormPageRoot
            tag={TAG}
            moduleName={resModule}
            addPageTitle={getTabTitle()}
            isDataLoading={getField(Fields.isDataLoading)}
            isDataFound={getField(Fields.isDataFound)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            md={6}>
            {createForm()}
        </FormPageRoot>
    }

    function createForm() {
        return <div>
            {/*news title, news date, news link, news description*/}
            <div>
                {/*news title*/}
                <ThemedInput
                    wrapperClassName={''}
                    className={''}
                    label={FormFields.title.title}
                    placeholder={FormFields.title.title}
                    id={FormFields.title.column}
                    type={'text'}
                    value={getFormField(FormFields.title)}
                    msg={getFormFieldMsg(FormFields.title)}
                    showLimitLabel={true}
                    maxLength={EVENT_INPUT_MAX_LEN}
                    required={true}
                    onChange={(e) => {
                        const value = e.target.value;
                        updateFormField(FormFields.title, value);
                        if (checkNullStr(value)) updateFormFieldMsg(FormFields.title, '');
                    }}
                />

                {/*news date*/}
                <ThemedInput
                    wrapperClassName={''}
                    className={''}
                    label={FormFields.date.title}
                    placeholder={FormFields.date.title}
                    id={FormFields.date.column}
                    type={'date'}
                    value={getFormField(FormFields.date)}
                    msg={getFormFieldMsg(FormFields.date)}
                    showLimitLabel={true}
                    maxLength={EVENT_INPUT_MAX_LEN}
                    required={true}
                    onChange={(e) => {
                        const value = e.target.value;
                        updateFormField(FormFields.date, value);
                        if (checkNullStr(value)) updateFormFieldMsg(FormFields.date, '');
                    }}
                />

                {/*news link*/}
                <ThemedInput
                    wrapperClassName={''}
                    className={''}
                    label={FormFields.link.title}
                    placeholder={FormFields.link.title}
                    id={FormFields.link.column}
                    type={'text'}
                    value={getFormField(FormFields.link)}
                    msg={getFormFieldMsg(FormFields.link)}
                    showLimitLabel={true}
                    maxLength={EVENT_INPUT_MAX_LEN}
                    required={true}
                    onChange={(e) => {
                        const value = e.target.value;
                        updateFormField(FormFields.link, value);
                        if (checkNullStr(value)) updateFormFieldMsg(FormFields.link, '');
                    }}
                />

                {/*desc*/}
                <ThemedInput
                    wrapperClassName={''}
                    className={''}
                    label={FormFields.desc.title}
                    placeholder={FormFields.desc.title}
                    id={FormFields.desc.column}
                    type={'text'}
                    value={getFormField(FormFields.desc)}
                    msg={getFormFieldMsg(FormFields.desc)}
                    showLimitLabel={true}
                    maxLength={EVENT_INPUT_MAX_LEN}
                    asTextArea={true}
                    style={{
                        minHeight: '50px',
                        height: '80px',
                        maxHeight: '200px'
                    }}
                    required={true}
                    onChange={(e) => {
                        const value = e.target.value;
                        updateFormField(FormFields.desc, value);
                        if (checkNullStr(value)) updateFormFieldMsg(FormFields.desc, '');
                    }}
                />

            </div>

            {/*by*/}
            <ThemedInput
                label={"Recommended by"}
                placeholder={"Recommended by"}
                value={getUserSessionField('fullName')}
                readOnly={true}
            />

            {/*footer*/}
            <div className={'mt-3'}>
                {/*msg-box*/}
                {checkNullStr(getField(Fields.panelMsg)) && <MsgBox color={getField(Fields.panelMsgColor, theme.text)}>
                    {getField(Fields.panelMsg)}
                </MsgBox>}

                {/*controls*/}
                <Flexbox className={'mt-2'} justifyAt={'center'} alignAt={'center'}>
                    <ThemedButton
                        className={'rounded-2 w-auto px-4 py-1'}
                        text={isFieldTrue(Fields.submitBtn_AsLoading) ? 'Uploading...' : 'Upload'}
                        variant={theme.primaryBlue}
                        hoverBgColor={theme.primaryBlueDark}
                        loadingWidth={'auto'}
                        asLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                        disabled={isFieldTrue(Fields.submitBtn_disabled)}
                        onClick={handleSubmit}
                    />
                </Flexbox>
            </div>
        </div>
    }

    function createSuccessDialog() {
        return <ThemedDialog
            className={"rounded-6 p-0 m-0"}
            titleClassName={'fs-lg mb-2'}
            open={isFieldTrue(Fields.showSuccessDialog)}
            title={"Thanks"}
            showClose={true}
            showFooter={false}
            closeOnEscape={true}
            closeOnOutsideClick={true}
            onHide={() => {
                const onHide = getField(Fields.successDialogOnHide);
                if (onHide) onHide();
                // updateField(Fields.showSuccessDialog, false);
            }}
        >
            <div className={'px-3'}>
                <div className={'m-0 p-0 pt-1 px-2 d-none-smx h-100 auth-img-wrapper w-100'}>
                    <Image
                        wrapperClassName={`w-100 rounded-6 overflow-hidden select-none`}
                        className={`auth-ra-img transition-sm`}
                        src={"https://cdn.pixabay.com/photo/2016/11/07/00/49/thanks-1804597_1280.jpg"}
                        // src={"https://cdn.pixabay.com/photo/2020/04/22/11/59/thank-you-5077738_1280.jpg"}
                        width={'100%'}
                        height={vhToPx('60vh') + 'px'}
                        objectFit={'cover'}
                        disableDrag={true}
                    />
                </div>

                <div>
                    <div className={'w-100 d-flex jc-center'}>
                        <Label className={'text-wrap fw-semi-bold mt-3 fs-normal'} color={theme.text80} textAt={'center'}>
                            {getDefStr(getField(Fields.panelMsg), Messages.formDataSaveSuccess)}
                        </Label>
                    </div>
                    <div className={'w-100 d-flex jc-center'}>
                        <Label className={'text-wrap fw-bold fs-xl'} color={theme.primaryBlue} textAt={'center'}>
                            {"Many thanks for your kind recommendation."}
                        </Label>
                    </div>
                </div>
            </div>
        </ThemedDialog>
    }

    //======================Request Functions start=====================
    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);

                const REQUEST_OPTIONS = {
                    fromRecommendPage: true,
                    formData: formData,
                };
                sendRequest({
                    reqUrl: ReqUrls.news__addEditPage_submit_formData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);

                            updateField(Fields.successDialogOnHide, (() => {
                                updateField(Fields.showSuccessDialog, false);
                                if (redirectUrl != -1) window.location.href = getDefStr(redirectUrl, ModuleRouteUrls[moduleName]);
                            }));
                            updateField(Fields.showSuccessDialog, true);
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================
    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = [
            FormFields.title,
            FormFields.date,
            FormFields.link,
            FormFields.desc,
        ];

        let verified = false;
        let colField = {};
        for (const field of requiredFields) {
            if (!checkNullStr(formData[field.column])) {
                colField = field;
                verified = false;
                break;
            } else {
                verified = true;
            }
        }
        if (!verified) {
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colField.title}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        return verified;
    }

    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function getTabTitle() {
        // const indexOfSecondS = moduleName.indexOf('s', moduleName.indexOf('s') + 1); // Find index of second 's'
        return `Recommend ${moduleName}`;
        // return moduleName
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        log(...[text]);
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default News_Recom_FormPage;
